module.exports = __webpack_public_path__ + "img/award (10).14b5f8ef.jpg";